import qrImg from "../images/qrImg.png";
import Loader from "../components/Common/Loader";

export const WaitComponent = () => {
  return (
    <div className="flex items-center flex-col justify-center w-full ">
      <Loader />
      <h3 className=" text-[18px] font-bold text-[#4DB748] mt-4">
        Please Wait!
      </h3>
      <p className=" text-[18px] font-medium text-black opacity-[0.70] mt-1">
        Generating QR Code
      </p>
    </div>
  );
};

export const NotFoundCom = ({ onClick, isLiveStreamStart }) => {
  return (
    <div className="flex items-center flex-col justify-center w-full">
      <h3 className=" text-[18px] font-semibold text-[#FF6161] mt-3">
        Vehicle Number Plate Not Found
      </h3>
      <p className=" text-[14px] font-medium ">
        Please check if you've captured it correctly.
      </p>
      <button
        onClick={onClick}
        disabled={!isLiveStreamStart}
        className={`text-[18px] font-bold text-white text-center bg-[#4DB748] rounded p-[14px] mt-3  ${isLiveStreamStart ? 'opacity-100' : 'opacity-50'}`}
      >
        Recapture Vehicle No.
      </button>
    </div>
  );
};

export const CaptureImgCom = ({ onClick, isLiveStreamStart }) => {
  return (
    <div className="flex items-center flex-col justify-center w-full ">
      <img className="h-[100px]  lgLp:h-[200px] w-auto  object-fill" src={qrImg} />
      <h2 className="text-[14px] lgLp:text-[16px] font-medium text-center mt-4 w-full">
        Capture Vehicle No To Generate QR Code
      </h2>
      <button
        onClick={onClick}
        disabled={!isLiveStreamStart}
        className={`text-[16px]  lgLp:text-[18px] font-bold text-white text-center bg-[#4DB748] rounded p-[14px] mt-3 ${isLiveStreamStart ? 'opacity-100' : 'opacity-50'}`}
      >
        Capture Vehicle No.
      </button>
    </div>
  );
};
